<template>
  <div
    id="dev-TokenInputCard"
    class="token-card"
    :class="{ 'readonly-card': readonly }"
  >
    <label class="token-card-label">{{ $t('map_navigation.terminal_token') }}</label>
    <div class="token-card-content">
      <input
        ref="inputField"
        :value="modelValue"
        type="text"
        class="token-input-field"
        :class="{ 'border-danger': error }"
        maxlength="4"
        :placeholder="placeholder || $t('map_navigation.token_placeholder')"
        :readonly="readonly"
        :aria-label="$t('map_navigation.terminal_token')"
        @input="$emit('update:modelValue', $event.target.value.toUpperCase())"
        @focus="handleFocus"
        @click="handleClick"
      >
    </div>
    <p
      v-if="error"
      class="token-error-message-inline"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
  export default {
    name: 'TokenInputCard',
    props: {
      modelValue: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      error: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      autofocus: {
        type: Boolean,
        default: true
      }
    },
    emits: ['update:modelValue'],
    mounted() {
      if (this.autofocus && !this.readonly) {
        this.$nextTick(() => {
          this.$refs.inputField?.focus()
        })
      }
    },
    methods: {
      handleFocus(event) {
        if (!this.readonly && event?.target?.select) {
          event.target.select()
        }
      },
      handleClick(event) {
        if (!this.readonly && event?.target?.select) {
          event.target.select()
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .token-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    background: #fff;
    border: 2px solid #e0e0e0;
    border-radius: 12px;
    margin-bottom: 20px;
    transition: all 0.3s ease;

    &:focus-within {
      border-color: #f58a48;
      background: #f8faff;
      box-shadow: 0 0 0 3px rgba(245, 138, 72, 0.1);
    }

    &.readonly-card:focus-within {
      border-color: #e0e0e0;
      background: #fff;
      box-shadow: none;
    }
  }

  .token-card-label {
    font-size: 12px;
    font-weight: 600;
    color: #424242;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .token-card-content {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 8px;
  }

  .token-input-field {
    flex: 1;
    width: 100%;
    max-width: 100%;
    padding: 10px 12px;
    font-size: 18px;
    text-align: center;
    letter-spacing: 4px;
    border: none;
    border-radius: 8px;
    font-weight: bold;
    color: #424242;
    background: #f5f5f5;
    -webkit-appearance: none;
    appearance: none;
    transition: all 0.2s ease;
    cursor: default;

    &:focus {
      outline: none;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(245, 138, 72, 0.1);
    }

    &[readonly]:focus {
      background: #f5f5f5;
      box-shadow: none;
      outline: none;
    }

    &:disabled,
    &[readonly] {
      background: #f5f5f5;
      cursor: default;
      color: #424242;
    }
  }

  .token-error-message-inline {
    font-size: 12px;
    color: #dc3545;
    margin: 8px 0 0 0;
    padding: 6px 10px;
    background: #fff5f5;
    border-radius: 6px;
    border-left: 3px solid #dc3545;
    animation: shake-error 0.4s ease;

    @keyframes shake-error {
      0%,
      100% {
        transform: translateX(0);
      }
      25% {
        transform: translateX(-4px);
      }
      75% {
        transform: translateX(4px);
      }
    }

    @media (max-width: 480px) {
      font-size: 11px;
      padding: 5px 8px;
    }
  }

  @media (max-width: 768px) {
    .token-card {
      padding: 12px;
      gap: 8px;
    }
  }

  @media (max-width: 480px) {
    .token-card {
      padding: 12px;
    }

    .token-input-field {
      font-size: 16px;
      padding: 8px 10px;
      letter-spacing: 3px;
    }
  }
</style>
